import { db, FieldValue } from 'helpers/firebase';
const serverTimestamp = FieldValue.serverTimestamp;


export const getStatisticsRef = (stat_id) => {
  console.log("inside getSatisticsRef = ", stat_id);
  if (!stat_id) {
    return Promise.reject("stat_id is required!");
  }
  return db.doc(`/statistics/${stat_id}`);
}